<script setup>
import {useStore} from "vuex";
import Swal from 'sweetalert2';

import DefaultButton from "@/components/global/buttons/DefaultButton.vue";

const props = defineProps({
  websiteId: {
    type: String,
    required: true,
  }
});

const store = useStore();

const deleteMerchantCustomer = () => {
  Swal.fire({
    icon: 'warning',
    title: 'Delete Customer',
    html: `Are you sure you want to remove delete this customer? This action is irreversible.`,
    confirmButtonText: 'Delete customer',
    showCancelButton: true,
    confirmButtonColor: "#F34F4F",
    showLoaderOnConfirm: true,
    backdrop: true,
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async () => {
      return await store.dispatch('merchant/deleteMerchantCustomer', props.websiteId)
        .then(({data}) => {
          return data;
        })

    },
  }).then((result) => {
    if (result.isConfirmed) {
      const {message} = result.value
      Swal.fire({
        icon: 'success',
        title: 'Customer Deleted!',
        text: message,
        didClose: () => window.location.href = '/websites',
      });
    }
  }).catch(error => {
    Swal.fire({
      icon: 'error',
      title: 'Error Deleting Customer',
      text: error.response.data.message,
    });
  })
};
</script>

<template>
  <div>
    <DefaultButton
      class="w-100"
      size="md"
      button-style="danger"
      @click="deleteMerchantCustomer"
    >
      <i class="fas fa-times xs-mr-5 text-white" />
      Cancel Account
    </DefaultButton>
  </div>
</template>
